import { render, staticRenderFns } from "./RecentActivity.vue?vue&type=template&id=27ebdc4a&scoped=true"
import script from "./RecentActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentActivity.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecentActivity.vue?vue&type=style&index=0&id=27ebdc4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ebdc4a",
  null
  
)

export default component.exports